import { render } from "./SignupPolicyModal.vue?vue&type=template&id=1ca9d1ed&ts=true"
import script from "./SignupPolicyModal.vue?vue&type=script&lang=ts"
export * from "./SignupPolicyModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__